import { render, staticRenderFns } from "./MSelect.vue?vue&type=template&id=729970c5&"
import script from "./MSelect.vue?vue&type=script&lang=js&"
export * from "./MSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports